<template>
    <div v-if="data&&!currentViewStyle" class="database-view" v-route-title="titleField?data.source[titleField.name]:'细览页面'">
        <div class="clear"></div>
        <div class="gengduo">
            <div class="xixun_title" v-if="titleField">
                <p>{{data.source[titleField.name]}}</p>
            </div>
            <div class="xixun_mian">
                <span v-for="field in metaFields" :key="field.name">{{field.title}}：
                    <news-field :data="data" :field="field"></news-field>
                </span>
            </div>
            <div class="contentss" v-if="contentField">
                <div class="content yq-news-section-details-page-content" v-html="formattedContent"></div>
            </div>
        </div>

    </div>
    <component v-else-if="data&&currentViewStyle" :is="currentViewStyle.template.component" :data="data"
               :config="currentViewStyle.config"></component>
</template>

<script>
    import sectionService from '../../service/section'
    import newsSectionService from '../../service/news-section'
    import datasourceConfigService from '../../service/datasource-config'
    import htmlUtils from '../../service/html-utils'
    import NewsField from '../../components/common/NewsField'
    import viewStyleService from '../../service/view-style'
    import templates from "../../components/templates"

    export default {
        name: "NewsSectionDataDetails",
        components: {NewsField},
        data(){
            return {
                section: null,
                sectionConfig: null,
                currentTab: null,
                currentDatasource: null,
                titleField: null,
                metaFields: [],
                contentField: null,
                data: null,
                currentViewStyle: null
            }
        },
        created(){
            this.init()
        },
        computed:{
            formattedContent(){
                if(this.data&&this.data.source[this.contentField.name]){
                    const content = this.data.source[this.contentField.name]
                    const pattern = /<[^>]+>/g
                    let arr
                    let prevEnd = 0
                    const result = []
                    while((arr = pattern.exec(content)) !== null){
                        content.substring(prevEnd, arr.index).split(/\r?\n/)
                            .forEach(p => result.push('<p>' + htmlUtils.escapeHtml(p) + '</p>' ))
                        result.push(arr[0])
                        prevEnd = pattern.lastIndex
                    }
                    if(prevEnd < content.length){
                        content.substring(prevEnd).split(/\n/)
                            .forEach(p => result.push('<p>' + htmlUtils.escapeHtml(p) + '</p>' ))
                    }
                    return result.join('')
                }else{
                    return ''
                }
            }
        },
        methods: {
            async init() {
                const response = await sectionService.getSection(this.$route.query.sectionId,
                    {templateId: this.$route.query.templateId})
                this.section = response.data
                if (this.section.config) {
                    this.sectionConfig = JSON.parse(this.section.config)
                    if (this.sectionConfig.tabs && this.sectionConfig.tabs.length > 0) {
                        this.currentTab = this.sectionConfig.tabs.find(item => item.name === this.$route.query.tabName)
                        if(this.currentTab){
                            this.currentDatasource = (await datasourceConfigService.getDatasourceConfig(this.currentTab.datasource.id)).data
                            if(this.currentTab.detailsStyle){
                                const viewStyle = (await viewStyleService.getViewStyle(this.currentTab.detailsStyle.id)).data
                                viewStyle.template = templates.find(item=>item.id===viewStyle.componentId)
                                this.currentViewStyle = viewStyle
                            }else{
                                this.currentViewStyle = null
                            }
                            this.currentDatasource.fields = JSON.parse(this.currentDatasource.fields)
                            for(const field of this.currentDatasource.fields){
                                if(!field.displayInDetails){
                                    continue
                                }
                                if(field.displayGroup==='TITLE'){
                                    this.titleField = field
                                }else if(field.displayGroup === 'CONTENT'){
                                    this.contentField = field
                                }else if(field.displayGroup === 'META'){
                                    this.metaFields.push(field)
                                }
                            }
                            await this.fetchData()
                        }
                    }
                }
            },
            async fetchData() {
                const params = {
                    pageId: this.$route.query.pageId,
                    templateId: this.$route.query.templateId,
                    sectionId: this.$route.query.sectionId,
                    tabName: this.currentTab.name,
                    query: '_id:'+this.$route.query.id,
                    viewName: 'details',
                    fields: this.currentViewStyle ? this.currentViewStyle.template.getFields(this.currentViewStyle.config):null,
                }
                const response = await newsSectionService.search(params)
                this.data = response.data.content[0]
            }
        }
    }
</script>

<style scoped>

</style>
